import store from './index'
import create from 'zustand'
import { State } from './types'

const useIsAuthenticated = () => {
  const useStore = create(store)

  return useStore((state: State) => !!state?.token)
}

export default useIsAuthenticated
